import { render, staticRenderFns } from "./DerDropdown.vue?vue&type=template&id=251a45de&"
import script from "./DerDropdown.vue?vue&type=script&lang=js&"
export * from "./DerDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports